import { searchCatalog, optionOf, optionSummary } from "./catalog.js";

const OPTIONS_PER_CODE = 5;

export const groupKey = code =>
  String(code)
    .trim()
    .toUpperCase();

export default {
  definition: {
    name: "search_parts",
    description:
      "Busca en el catálogo cada código de pieza que mandó el vendedor (código NKR, unificado, OE o supersesión) y le muestra hasta 5 opciones por código en una tarjeta, donde elige una con un clic. Llámala una sola vez con todos los códigos de la lista. Sólo para códigos: para buscar por descripción usa search_parts_by_text. Devuelve, por código, las opciones con su precio online y stock en la tienda del vendedor, cuál está elegida y, si hay un vehículo elegido, si cada opción le queda.",
    strict: true,
    input_schema: {
      type: "object",
      properties: {
        items: {
          type: "array",
          items: {
            type: "object",
            properties: {
              code: {
                type: "string",
                description: "El código tal como lo escribió el vendedor"
              },
              quantity: {
                type: "integer",
                description: "Cantidad pedida; 1 si no la dijo"
              }
            },
            required: ["code", "quantity"],
            additionalProperties: false
          }
        }
      },
      required: ["items"],
      additionalProperties: false
    }
  },

  async run({ items }, ctx) {
    const groups = await Promise.all(
      items.map(async item => {
        const hits = await searchCatalog(ctx, item.code, OPTIONS_PER_CODE);
        return {
          key: groupKey(item.code),
          code: item.code,
          quantity: Math.max(1, item.quantity || 1),
          options: hits.map(hit => optionOf(hit, ctx))
        };
      })
    );
    return {
      card: { type: "partOptions", groups },
      content: JSON.stringify({
        shownToUserAsCard: true,
        results: groups.map(group => ({
          code: group.code,
          quantity: group.quantity,
          // Con una sola opción la tarjeta ya la deja elegida
          selected:
            group.options.length === 1 ? group.options[0].nkrCode : null,
          options: group.options.map(optionSummary)
        }))
      })
    };
  }
};
